import React from 'react';
import loadable from '@loadable/component';
import { ChartConfiguration } from 'chart.js';

const ReactChart = loadable(() =>
  import(/* webpackChunkName: "react-chart" */ './ReactChart'),
);

type Props = React.HTMLProps<HTMLCanvasElement> & {
  config: ChartConfiguration;
};

export class LazyReactChart extends React.Component<Props> {
  componentDidCatch(error: Error, info: any) {
    console.log(error, info);
  }

  render() {
    return <ReactChart {...this.props} />;
  }
}
